import Home from '@views/Home';

export default [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '@views/Contact'),
  },
  {
    path: '/tenant-area',
    name: 'tenantArea',
    component: () => import(/* webpackChunkName: "tenantArea" */ '@views/TenantArea'),
  },
  {
    path: '/legal',
    name: 'legal',
    component: () => import(/* webpackChunkName: "legal" */ '@views/Legal'),
  },
];
